<template>
  <div class="language-page">
    <div class="header">
      <span class="back-btn" @click="$router.go(-1)"> &lt; {{ $t('Cancel') }} </span>
      <span class="title">{{ $t('Switch Language') }}</span>
    </div>

    <div class="lang-list">
      <div
        class="lang-item"
        v-for="item in languageOptions"
        :key="item.code"
        @click="changeLang(item.code)"
      >
        <span>{{ item.label }}</span>
        <span v-if="currentLang === item.code" class="check-mark">✓</span>
      </div>
    </div>
  </div>
</template>

<script>
import { saveUserLanguage, LANGUAGE_OPTIONS } from '@/utils/language';

export default {
  name: 'language',
  data() {
    return {
      languageOptions: LANGUAGE_OPTIONS,
      currentLang: this.$i18n ? this.$i18n.locale : 'zh'
    };
  },
  methods: {
    changeLang(lang) {
      this.currentLang = lang;
      if (this.$i18n) {
        this.$i18n.locale = lang;
      }
      saveUserLanguage(lang);

      setTimeout(() => {
        this.$router.go(-1);
      }, 200);
    }
  }
};
</script>

<style scoped>
.language-page { 
  min-height: 100vh; 
  background-color: #1a1a1a; 
  color: #e0e0e0; 
}
.header { 
  display: flex; 
  align-items: center; 
  padding: 15px 20px; 
  background: #262626; 
  border-bottom: 1px solid rgba(255,255,255,0.05); 
}
.back-btn { 
  font-size: 16px; 
  margin-right: 20px; 
  cursor: pointer; 
}
.title { 
  font-size: 16px; 
  font-weight: bold; 
  flex: 1;
  text-align: center;
  padding-right: 30px; 
}
.lang-list { 
  padding: 10px 20px; 
}
.lang-item { 
  display: flex; 
  justify-content: space-between; 
  padding: 18px 0; 
  border-bottom: 1px solid rgba(255,255,255,0.05); 
  cursor: pointer; 
  font-size: 15px;
}
.check-mark { 
  color: #4a90e2; 
  font-weight: bold; 
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/language.vue